import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "addingVouchersWidget"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'AwaitVoucherPanel',
    props: {
        polling: { type: Boolean }
    },
    emits: ["cancel"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        function cancel() {
            emit('cancel');
        }
        return (_ctx, _cache) => {
            const _component_v_progress_linear = _resolveComponent("v-progress-linear");
            return (_ctx.polling)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "float-left" }, "Searching for new vouchers . . .", -1)),
                    _createElementVNode("div", {
                        class: "float-right",
                        onClick: _cache[0] || (_cache[0] = ($event) => (cancel()))
                    }, "Cancel"),
                    _createVNode(_component_v_progress_linear, {
                        indeterminate: "",
                        color: "#332847"
                    })
                ]))
                : _createCommentVNode("", true);
        };
    }
});
